var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraftPage = function SvgDraftPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.145 23.875"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#36f",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.292 5.159h-4.877a.384.384 0 0 1-.384-.384V.795q.242.065.443.23l4.552 3.794q.172.143.266.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.362 4.409 12.78 2.257V4.41zm2.485 1.5h-5.431a1.134 1.134 0 0 1-1.134-1.134V.447a.44.44 0 0 1 .441-.441c.454 0 .884.155 1.23.441l4.554 3.796c.406.335.639.836.639 1.367a.296.296 0 0 1-.299.299"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f2f4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.234 23.25H1.91a1.286 1.286 0 0 1-1.285-1.286V1.91c0-.708.577-1.285 1.285-1.285h7.195v4.15a3.315 3.315 0 0 0 3.31 3.311h5.105v13.88c0 .708-.576 1.285-1.285 1.285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36f",
    d: "M1.91 1.25a.67.67 0 0 0-.66.66v20.055c0 .357.302.66.66.66h14.324c.358 0 .66-.303.66-.66V8.71h-4.48A3.94 3.94 0 0 1 8.48 4.774V1.25zm0-1.25h7.82v4.775a2.69 2.69 0 0 0 2.685 2.686h5.73v14.505c0 1.05-.859 1.91-1.91 1.91H1.91c-1.05 0-1.91-.86-1.91-1.91V1.909C0 .86.86 0 1.91 0"
  }))));
};
export default SvgDraftPage;